/**
 * Strings both credited-person surfaces render.
 *
 * Every line states a **consequence**, never a reason. The rationale for each
 * decision lives in the UI/UX pack and this repo's PRD-TDD, which is where a
 * reviewer reads it — «the catalog» is not a word that exists in an operator's
 * job.
 */
export const sharedCopy = {
  crumbs: {
    console: 'لوحة التشغيل',
    register: 'المنسوبون',
  },

  /**
   * `CREDIT_ROLES` carries ASCII tokens on the wire — `director`, `writer`,
   * `actor` — because a service parses them and the provider fill maps onto
   * them. What an operator reads is Arabic, and the mapping is the console's:
   * the vocabulary is the setting's, the wording is the interface's.
   *
   * **A token with no entry renders as itself.** A seventh role added to the
   * setting appears in the select and on the badge under its own name rather
   * than being dropped — a value the operator cannot name is still a value, and
   * a missing one is a hole.
   */
  roles: {
    director: 'إخراج',
    producer: 'إنتاج',
    writer: 'كتابة',
    actor: 'تمثيل',
    composer: 'تأليف موسيقي',
    cinematographer: 'تصوير',
  } as Readonly<Record<string, string>>,

  /** `content_type` on the wire — the two types this platform ships. */
  contentTypes: {
    film: 'فيلم',
    series: 'مسلسل',
  } as Readonly<Record<string, string>>,

  publicPage: 'الصفحة العامّة',

  /**
   * Both surfaces draw the role set, and both meet the same empty case: a role
   * is a property of a credit, and a record with no credits has none. The cell
   * says what is absent rather than sitting blank — an empty cell in a table of
   * populated rows reads as missing data instead of as a true zero.
   */
  noRoles: 'لا نِسَب بعد',

  actions: {
    save: 'احفظ',
    cancel: 'ألغِ',
    add: 'أضف',
  },
} as const;

export function roleLabel(token: string): string {
  return sharedCopy.roles[token] ?? token;
}

export function contentTypeLabel(token: string): string {
  return sharedCopy.contentTypes[token] ?? token;
}
